import React, { useState, useEffect } from 'react';

const TextArea = (props) => {
    const {
        prevSelectedValue = '',
        prevSelectedCheckbox = false,
        onSelectedValueChange,
    } = props;

    const [textAnswer, setTextAnswer] = useState('');
    const [checkbox, setCheckbox] = useState(false);

    // Initiale Werte setzen (läuft nur einmal beim Laden einer neuen Frage)
    useEffect(() => {
        // console.log("prevSelectedCheckbox aktualisiert:", prevSelectedCheckbox);
        setCheckbox(prevSelectedCheckbox);
        setTextAnswer(prevSelectedCheckbox ? "Kann/Möchte ich nicht beantworten" : prevSelectedValue || '');
    }, [prevSelectedValue, prevSelectedCheckbox]);

    const handleCheck = () => {

        setCheckbox((prev) => {
            const newCheckedState = !prev;
            const newTextValue = newCheckedState ? "Kann/Möchte ich nicht beantworten" : '';
            setTextAnswer(newTextValue);
            onSelectedValueChange(newTextValue, true, newCheckedState);
            return newCheckedState;
        });
    };

    const textChange = (event) => {
        const { value } = event.target;
        setCheckbox(false);
        setTextAnswer(value);
        // console.log("Text geändert:", value, "Checkbox wird auf false gesetzt");
        onSelectedValueChange(value, true, false);
    };

    return (
        <div className="bubbleTextAnswers">
            <input
                type="checkbox"
                checked={checkbox}
                id="noAnswer"
                onChange={handleCheck}
                name="noAnswer"
                value="Kann/Möchte ich nicht beantworten"
            />
            <label className="bubbleLabel" htmlFor="noAnswer">
                Kann/Möchte ich nicht beantworten
            </label>

            <textarea
                className="bubbleText_answer"
                autoFocus
                value={textAnswer}
                onChange={textChange}
                disabled={checkbox} // Textarea ist deaktiviert, wenn Checkbox aktiv ist
            />
        </div>
    );
};

export default TextArea;
